import type {
  PaymentProduct,
  PaymentSubscription,
  PaymentPlatform,
} from '~/models/payment';
import type {
  PaymentProductResponse,
  PaymentSubscriptionResponse,
} from '~/repositories/payment-repository';

export const convertIPaymentProductToPaymentProduct = (
  response: PaymentProductResponse | undefined
): PaymentProduct | undefined => {
  if (!response) {
    return;
  }

  return {
    id: response.id ?? '',
    name: response.name ?? '',
    platform: response.platform as PaymentProduct['platform'],
    trialDays: response.trial_days ?? 0,
    price: response.price ?? 0,
    termByMonth: response.term_by_month ?? 0,
  };
};

export const convertIPaymentSubscriptionToPaymentSubscription = (
  response: PaymentSubscriptionResponse
): PaymentSubscription | undefined => {
  if (!response) return;

  const [chargeFailedAt, chargeFailedAtISOString] =
    stringDateToISOStringAndText(response.charge_failed_at ?? 0);

  const [startedAt, startedAtISOString] = stringDateToISOStringAndText(
    response.started_at ?? 0
  );

  const [expiresAt, expiresAtISOString] = stringDateToISOStringAndText(
    response.expires_at ?? 0
  );

  const [resumeAt, resumeAtISOString] = stringDateToISOStringAndText(
    response.resume_at ?? 0
  );

  const [nextChargeAt, nextChargeAtISOString] = stringDateToISOStringAndText(
    response.next_charge_at ?? 0
  );

  const [updatedAt, updatedAtISOString] = stringDateToISOStringAndText(
    response.updated_at ?? 0
  );

  return {
    id: response.id ?? '',
    userId: response.user_id ?? '',
    paymentPlatform: response.payment_platform as PaymentPlatform,
    product: convertIPaymentProductToPaymentProduct(response.product),
    startedAt,
    startedAtISOString,
    expiresAt,
    expiresAtISOString,
    resumeAt,
    resumeAtISOString,
    isAutoRenewable: response.is_auto_renewable ?? false,
    isTrial: response.is_trial ?? false,
    isPending: response.is_pending ?? false,
    chargeFailedAt,
    chargeFailedAtISOString,
    nextChargeAt,
    nextChargeAtISOString,
    updatedAt,
    updatedAtISOString,
  };
};

const stringDateToISOStringAndText = (
  stringDate: string | number
): [Date, string] => {
  const date = new Date(stringDate);
  return [date, date.toISOString()];
};
